export const LOGIN_PS = 'パスワード'
export const REGISTER_PS = 'パスワード'
export const REGISTER_CPS = 'パスワードを認証する'
